<!-- 配件采购历史 -->
<template>
    <div v-loading="loading" id="APPurchaseHistory">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">单据类型</div>
                <div class="search-item goods-categories">
                    <el-select
                        size="small"
                        style="width: 120px"
                        v-model="searchData.OrderType"
                    >
                        <el-option label="全部" value></el-option>
                        <el-option label="采购单" value="1"></el-option>
                        <el-option label="采购退货" value="2"></el-option>
                    </el-select>
                </div>
                <div class="search-name" v-if="permission2.checkSupplier || permission.addSupplier || permission.editSupplier">供应商</div>
                <el-select
                    v-if="permission2.checkSupplier || permission.addSupplier || permission.editSupplier"
                    size="small"
                    class="search-item"
                    style="width: 140px"
                    v-model="searchData.EntpCusId"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    @visible-change="customerVisibleChange($event)"
                    :remote-method="searchSupplier"
                    v-select-scroll-more="searchSupplierLoad"
                    placeholder="选择供应商"
                >
                    <el-option
                        v-for="optionItem in supplierOptions"
                        :key="optionItem.EntpCusId"
                        :data-msg="optionItem"
                        :label="optionItem.EntpCusName"
                        :value="optionItem.EntpCusId"
                    ></el-option>
                    <el-option v-if="selLoading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                </el-select>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories">
                    <el-select
                        v-model="searchData.BrandName"
                        filterable
                        clearable
                        size="small"
                        :loading="selLoading"
                        @visible-change="brandVisibleChange($event)"
                        style="width: 120px"
                    >
                        <el-option label="全部" value></el-option>
                        <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories">
                    <el-select
                        size="small"
                        style="width: 120px"
                        :loading="selLoading"
                        v-model="searchData.Cate"
                        filterable
                        clearable
                        @visible-change="classifyVisibleChange($event)"
                    >
                        <el-option label="全部" value></el-option>
                        <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <div class="search-name" v-if="Source != 0">业务员</div>
                <el-select
                    v-if="Source != 0"
                    v-model="searchData.SId"
                    class="search-item"
                    style="width: 100px"
                    filterable
                    clearable
                    remote
                    size="small"
                    placeholder="请选择"
                    @visible-change="siVisibleChange($event)"
                >
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" v-if="isCanTBSet" icon="el-icon-setting" class="search-btn" type="primary"  @click="showTableSetDialog"
                    style="height: 32px;background-color:#409EFF;"
                >表格设置</el-button>
            </div>
        </div>
        <div>
            <el-card class="box-card">
                <div class="data-count">
                    <div class="data-item">
                        <p>平均</p>
                        <p>{{ avg }}</p>
                    </div>
                    <div class="data-item" v-for="(stat, index) in statData" :key="index">
                        <p>
                            {{ month - index > 0 ? year : year - 1 }} -
                            {{ month - index > 0 ? month - index : month - index + 12 }}
                        </p>
                        <p>{{ stat }}</p>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 0px">
                <!-- <el-table-column width="180px" prop="OrderCode" label="订单号" show-overflow-tooltip></el-table-column>
                <el-table-column
                    prop="EntpCusName"
                    label="供应商"
                    show-overflow-tooltip
                    v-if="permission2.checkSupplier || permission.addSupplier || permission.editSupplier"
                ></el-table-column>
                <el-table-column min-width="100px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100px" prop="EntpTempGoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip width="70px" prop="Count" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="70px" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="Origin" label="产地"></el-table-column>
                <el-table-column show-overflow-tooltip width="120px" prop="StoName" label="出/入仓库"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" :render-header="renderHeader" prop="Price" label="采购价"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="SubmitTime" label="采购时间"></el-table-column>
                <el-table-column prop="SName" label="业务员" width="80px" show-overflow-tooltip v-if="Source != 0"></el-table-column> -->
                <template v-for="(item,index) in columnShowSets">
                    <el-table-column
                        v-if="item.ColumnCode == 'Price'"
                        :render-header="renderHeader"
                        v-bind:key="item.ColumnCode + index"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :prop="item.ColumnCode"
                        :label="item.ColumnName" 
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-else-if="item.ColumnCode == 'SName' && Source != 0"
                        v-bind:key="item.ColumnCode + index"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :prop="item.ColumnCode"
                        :label="item.ColumnName" 
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-else-if="item.ColumnCode != 'EntpCusName'"
                        v-bind:key="item.ColumnCode + index"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :prop="item.ColumnCode"
                        :label="item.ColumnName" 
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-else-if="permission2.checkSupplier || permission.addSupplier || permission.editSupplier"
                        v-bind:key="item.ColumnCode + index"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :prop="item.ColumnCode"
                        :label="item.ColumnName" 
                        show-overflow-tooltip
                    ></el-table-column>
                </template>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!-- 自定义列 -->
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import tableSets from '@/components/common/tableSets_v2.vue';
export default {
    name: '',
    components: { 
        tableSets 
    },
    props: {
        EntpTempGoodsId: {
            type: String
        },
        EntpCusId: {
            type: String
        },
        EntpCusName: {
            type: String
        },
        NoInit: {
            type: Boolean
        },
        Source: {
            type: Number
        }
    }, //0来自销售，1来自采购
    data() {
        return {
            loading: false,
            selLoading: false,
            typeList: [],
            brandList: [],
            dialogType: '-1',
            editData: {},
            dialogVisible: false,
            isCanTBSet: false,
            tableCode: 'PurHistory',
            columnShowSets:[],
            tableSetsVisible:false,
            searchData: {
                OrderType:"",
                GoodsId: this.EntpTempGoodsId,
                EntpCusId: this.EntpCusId, //这个在这里代表的是供应商
                BrandName: '',
                Cate: '',
                SId: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            SIdList: [],
            tableDataLength: 0,
            statData: [],
            avg: 0,
            month: 0,
            year: 0,
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            permission: {},
            permission2: {}
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('supplierBuyOrder');
        this.permission2 = this.$util.getPermission('salesOrder');

        if (this.EntpCusId) {
            this.supplierOptions.push({
                EntpCusId: this.EntpCusId,
                EntpCusName: this.EntpCusName
            });
        }
        if (this.tableCode) {
            this.getConfigByCodes();
            this.getSetsData();
        }
        this.year = new Date().getFullYear();
        this.month = new Date().getMonth() + 1;
        if (!this.NoInit) this.getTableData();
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['ygsfkzdylb'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'ygsfkzdylb': //是否可自定义列表
                                    this.isCanTBSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        closeDialog(isEdit) {
            this.tableSetsVisible = false;
            if(isEdit){
                this.$router.go(0);
            }
        },
        renderHeader(h, { column }) {
            const purPrice = [
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '当采购单具有分摊成本时，当前的采购价是：采购价 + 分摊成本'
                )
            ];
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        purPrice,
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.selLoading = true;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
            this.selLoading = false;
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            if (!this.selLoading) {
                this.supplierForm.Page += 1;
                this.searchSupplier();
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.supplierOptions.length == 0) that.searchSupplier('');
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length == 0) that.getSIdList();
            }
        },
        getSIdList() {
            this.$util.getPurchaserList().then(data => {
                this.SIdList = data;
            });
        },
        searchGoodsBrand() {
            this.selLoading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsType() {
            this.selLoading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                GoodsId: this.EntpTempGoodsId,
                EntpCusId: this.EntpCusId,
                BrandName: '',
                Cate: '',
                SId: '',
                page: 1,
                limit: 10
            };
        },
        // 更新表格数据
        updateTableData(id) {
            this.resetSearch();
            this.searchData.GoodsId = id;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetGoodsPurHisList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = {};
                    this.tableData = data.PurData;
                    this.tableDataLength = res.count;
                    this.statData = data.StatData;
                    this.avg = data.Avg;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        //当汽配分类下拉框出现时触发
        classifyVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    flex-direction: row-reverse;
}
.data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 12.5%;
    border-left: 1px solid @border4Color;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
        margin-bottom: 5px;
    }
}
.search-ctn {
    .search-ctn-left {
        margin-top: 5px;
        .search-name,
        .search-item,
        button {
            margin-bottom: 10px;
        }
    }
    .search-btn,
    .search-item {
        margin-bottom: 0;
    }
}
</style>
